import { Dispatch } from 'redux';

import { IApplicationState } from '../../../di/store';
import { createActionCreator } from '../../../utils/fsa';
import { IPriceChangeSubscriptionData } from '../reducers/price_change_subscription';

// tslint:disable-next-line:variable-name
export const setoffer_id = createActionCreator<{
  offer_id: number;
  user?: 'user' | 'anonymus';
}>('price_change_subscription/set_offer_id');

export const setSubsctiptionData = createActionCreator<
  IPriceChangeSubscriptionData>('price_change_subscription/set_subscription_data');

export const subscribe = createActionCreator<{
  user?: 'user' | 'anonymus';
  subscriptionData: IPriceChangeSubscriptionData;
  formSend?: boolean;
}>('price_change_subscription/subscribe');

export const unsubscribe = createActionCreator<{
  subscriptionData: IPriceChangeSubscriptionData;
  unsubscribeFormState: boolean;
  formSend?: boolean;
}>('price_change_subscription/unsubscribe');

export const setSubscribeState = createActionCreator<{
  hasSubscription: boolean;
  formSend?: boolean;
  unsubscribeFormState?: boolean;
}>('price_change_subscription/set_subscribe_state');

export const closePopup = () => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState) => {
  const { formSend, hasSubscription, unsubscribeFormState } = getState().priceChangeSubscription;
  dispatch(setSubscribeState({
    hasSubscription: formSend ?
        !hasSubscription
        : hasSubscription,
    formSend: false,
    unsubscribeFormState: (formSend && hasSubscription && unsubscribeFormState) ? false : unsubscribeFormState,
  }));
};



// WEBPACK FOOTER //
// ./src/bundles/price_change_subscription/action_creators/price_change_subscription.ts